export enum TipoBeneficiosEnum {
    ALIMENTACAO = 1,
    REFEICAO,
    COMBUSTIVEL,
    SAUDE,
    ODONTOLOGICO,
    CRECHE,
    CULTURA,
    PRESENTE,
    OUTROS,
    TRANSPORTE,
    SEGURODEVIDA,
    FLEXIVEL
}

export const TipoBeneficios = {
    [TipoBeneficiosEnum.ALIMENTACAO]: {
        nome: 'Vale-alimentação',
        tipobeneficiointerno: TipoBeneficiosEnum.ALIMENTACAO
    },
    [TipoBeneficiosEnum.REFEICAO]: {
        nome: 'Vale-refeição',
        tipobeneficiointerno: TipoBeneficiosEnum.REFEICAO
    },
    [TipoBeneficiosEnum.COMBUSTIVEL]: {
        nome: 'Combustível',
        tipobeneficiointerno: TipoBeneficiosEnum.COMBUSTIVEL
    },
    [TipoBeneficiosEnum.SAUDE]: {
        nome: 'Plano de saúde',
        tipobeneficiointerno: TipoBeneficiosEnum.SAUDE
    },
    [TipoBeneficiosEnum.ODONTOLOGICO]: {
        nome: 'Plano odontológico',
        tipobeneficiointerno: TipoBeneficiosEnum.ODONTOLOGICO
    },
    [TipoBeneficiosEnum.CRECHE]: {
        nome: 'Auxílio creche',
        tipobeneficiointerno: TipoBeneficiosEnum.CRECHE
    },
    [TipoBeneficiosEnum.CULTURA]: {
        nome: 'Vale-cultura',
        tipobeneficiointerno: TipoBeneficiosEnum.CULTURA
    },
    [TipoBeneficiosEnum.PRESENTE]: {
        nome: 'Vale-presente',
        tipobeneficiointerno: TipoBeneficiosEnum.PRESENTE
    },
    [TipoBeneficiosEnum.OUTROS]: {
        nome: 'Outros',
        tipobeneficiointerno: TipoBeneficiosEnum.OUTROS
    },
    [TipoBeneficiosEnum.TRANSPORTE]: {
        nome: 'Vale-transporte',
        tipobeneficiointerno: TipoBeneficiosEnum.TRANSPORTE
    },
    [TipoBeneficiosEnum.SEGURODEVIDA]: {
        nome: 'Seguro de vida',
        tipobeneficiointerno: TipoBeneficiosEnum.SEGURODEVIDA
    },
    [TipoBeneficiosEnum.FLEXIVEL]: {
        nome: 'Flexível',
        tipobeneficiointerno: TipoBeneficiosEnum.FLEXIVEL
    },
};

export enum SituacaoBeneficioEnum {
    INATIVO,
    ATIVO,
    CANCELADO,
    SUSPENSO,
    REATIVADO
}
